<template>
  <div class="layout">
    <banner />
    <topbar />
    <section id="content" class="content container">
      <banner-slider />
      <keep-alive :include="['home']">
        <router-view />
      </keep-alive>
    </section>
    <bottombar />
    <modals />
    <v-cookies />
  </div>
</template>

<script>
import Banner from '@/components/Banner';
import Topbar from '@/components/Topbar';
import Bottombar from '@/components/Bottombar';
import Modals from '@/components/Dialog';
import VCookies from '@/components/VCookies.vue';
import BannerSlider from '@/components/BannerSlider';

export default {
  components: {
    Topbar,
    Banner,
    Bottombar,
    Modals,
    BannerSlider,
    VCookies,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.content {
  padding-top: 70px;
  padding-bottom: 30px;

  @include notebook {
    padding-top: 55px;
  }
}

.layout {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
}
</style>
